
<form [formGroup]="form">
  <pim-input-select [values]="languages$ | async" formControlName="contentLanguage"></pim-input-select>
</form>
